import {FuseRouteItemType} from '@fuse/utils/FuseUtils';

import {AUTH_ROLES} from '@/app/auth/authRoles';

import IdvDocsSubmittedPage from './IdvDocsSubmittedPage';

const IdvDocsSubmittedRoute: FuseRouteItemType = {
  path: '',
  element: <IdvDocsSubmittedPage />,
  auth: AUTH_ROLES.parent, // []
  children: [],
};

export default IdvDocsSubmittedRoute;
